import "./../scss/main.scss";
import "./../scss/eligibility-test.scss";
import "./../scss/eligibleForm.scss";

import "bootstrap";
